<template>
  <v-container :id="!centered && !$vuetify.breakpoint.xs?'logoContainer':''" class="logo fill-height pa-0">
    <v-row align="center" justify="center" justify-sm="start">
      <img style="margin: auto" :class="'--'+$vuetify.breakpoint.name"
             :src="src.includes('http')? src : require('@/assets/' + src)" :alt="alt">

    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Logos',
  props: {
    centered: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      default: '',
      required: true
    },
    maxHeight: {
      type: String,
      default: '100px'
    },
    aspectRatio: {
      type: Number,
      default: 2.3334
    },
    alt: {
      type: String,
      default: ''
    },
    large: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss"  scoped>
  .--xs{
    margin: auto;
    max-width: 220px;
  }
  .logo {
    height: 128px;
    min-width: 300px;
    max-width: 300px;
    display: flex;
    align-content: center;
    justify-content: center;
    img, object {
      max-height: 118px;
      max-width: 270px;
      margin: auto;
    }
  }
  #logoContainer{
    margin-left: 0px;
    z-index: 5;
  }
</style>
<style>
  .v-responsive .v-image .--sm{
    display: none !important;
  }
</style>
